import { render, staticRenderFns } from "./balance-amount.vue?vue&type=template&id=1213f407"
import script from "./balance-amount.vue?vue&type=script&lang=js"
export * from "./balance-amount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports